"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export interface FilterValues {
  documentNumber: string;
  vendorName: string;
  startDate: string;
  endDate: string;
  status: string;
}

interface DataFilterProps {
  filters: FilterValues;
  onFiltersChange: (filters: FilterValues) => void;
  statusOptions: { value: string; label: string }[];
}

export function DataFilter({ filters, onFiltersChange, statusOptions }: DataFilterProps) {
  function updateFilter(key: keyof FilterValues, value: string) {
    onFiltersChange({ ...filters, [key]: value });
  }

  function resetFilters() {
    onFiltersChange({
      documentNumber: "",
      vendorName: "",
      startDate: "",
      endDate: "",
      status: "",
    });
  }

  return (
    <div className="rounded-lg border bg-white p-4 dark:bg-zinc-950">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <div className="space-y-1">
          <Label htmlFor="documentNumber" className="text-xs">单据号</Label>
          <Input
            id="documentNumber"
            placeholder="模糊搜索"
            value={filters.documentNumber}
            onChange={(e) => updateFilter("documentNumber", e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="vendorName" className="text-xs">供应商名称</Label>
          <Input
            id="vendorName"
            placeholder="模糊搜索"
            value={filters.vendorName}
            onChange={(e) => updateFilter("vendorName", e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="startDate" className="text-xs">起始日期</Label>
          <Input
            id="startDate"
            type="date"
            value={filters.startDate}
            onChange={(e) => updateFilter("startDate", e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="endDate" className="text-xs">截止日期</Label>
          <Input
            id="endDate"
            type="date"
            value={filters.endDate}
            onChange={(e) => updateFilter("endDate", e.target.value)}
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="status" className="text-xs">状态</Label>
          <Select
            value={filters.status}
            onValueChange={(v) => updateFilter("status", v)}
          >
            <SelectTrigger id="status">
              <SelectValue placeholder="全部状态" />
            </SelectTrigger>
            <SelectContent>
              {statusOptions.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="mt-3 flex justify-end">
        <Button variant="outline" size="sm" onClick={resetFilters}>
          重置筛选
        </Button>
      </div>
    </div>
  );
}